// extracted by mini-css-extract-plugin
export var arrow = "_a-8";
export var fadeIn = "_a-1";
export var header = "_a-4";
export var image = "_a-3";
export var link = "_a-7";
export var modal = "_a-2";
export var overlay = "_a-0";
export var subtitle = "_a-6";
export var title = "_a-5";